import {
  SET_USER,
  FETCH_USER_ADMIN_RESOURCES_SUCCEEDED
} from "../constants/actionTypes";

// reducer initial state
export const initialState = {
  loaded: false
};

// reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        ...action.payload.user,
        loaded: true
      };
    case FETCH_USER_ADMIN_RESOURCES_SUCCEEDED:
      return {
        ...state,
        adminResources: action.payload.resources
      }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/user.js